module.exports = __webpack_public_path__ + "static/foundher-8517f77387cf8fe5869544ce5c01a8df.jpg";